import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import useDialog from 'hooks/useDialog';
import useExclusiveOffer from 'hooks/useExclusiveOffer';
import useUtmsFromSession from 'hooks/useUtmsFromSession';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';
import placeholder from 'lib/placeholder';

const CouponDialog = dynamic(() => import('./CouponDialog'), {
  ssr: false,
});

const GoToStoreButton = ({
  className,
  gaEventCategory,
  gaEventCategoryPostfix,
  offerCoupon = null,
  offerCta = null,
  offerId,
  offerSlug,
  offerUserVisibility,
}) => {
  const { showDialog } = useDialog();
  const { isOfferBlocked } = useExclusiveOffer();
  const { utmParams } = useUtmsFromSession();

  if (offerCoupon) {
    return (
      <Button
        className={className}
        disabled={isOfferBlocked(offerUserVisibility, offerSlug)}
        size="size1"
        type="primary"
        full
        onClick={() => {
          sendEvent({
            action: 'modal_coupon_open',
            category: 'active_offer_buy',
            label: offerCta ?? placeholder('actions.goToStore'),
          });
          showDialog(CouponDialog, {
            offerCta,
            offerCoupon,
            offerId,
            utmParams,
            gaEventCategoryPostfix,
          });
        }}
      >
        {offerCta ?? placeholder('actions.goToStore')}
      </Button>
    );
  }

  return (
    <Button
      as="a"
      className={className}
      disabled={isOfferBlocked(offerUserVisibility, offerSlug)}
      href={toOfferRedirectLink(offerId, utmParams)}
      size="size1"
      target="_blank"
      type="primary"
      full
      onClick={() => {
        sendEvent({
          action: 'go_store',
          category: `${gaEventCategory}${
            gaEventCategoryPostfix ? `_${gaEventCategoryPostfix}` : ''
          }`,
          label: offerCta ?? placeholder('actions.goToStore'),
        });
      }}
    >
      {offerCta ?? placeholder('actions.goToStore')}
    </Button>
  );
};

GoToStoreButton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  gaEventCategoryPostfix: PropTypes.string,
  offerCoupon: PropTypes.string,
  offerCta: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerSlug: PropTypes.string.isRequired,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default GoToStoreButton;
